import React from 'react';
import { Layout } from 'antd';
import useAccount from 'hooks/useAccount';
import { Loading, Breadcrumb } from 'components';
import Header from './Header';
import Sider from './Sider';
import Footer from './Footer';
import { connect } from 'react-redux';

const DashboardLayout = ({ children, collapsed }) => {
  const { isAuthenticated, loading } = useAccount();

  return loading || !isAuthenticated ? (
    <Loading />
  ) : (
    <Layout className="DashboardLayout">
      <Layout.Sider width={256} collapsed={collapsed}>
        <Sider collapsed={collapsed} />
      </Layout.Sider>
      <Layout>
        <Layout.Header>
          <Header />
        </Layout.Header>
        <Layout.Content>
          <Breadcrumb />
          <div className="Content">{children}</div>
          <Layout.Footer>
            <Footer />
          </Layout.Footer>
        </Layout.Content>
      </Layout>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  collapsed: state.global.collapsed,
});

export default connect(mapStateToProps)(DashboardLayout);
